	<template>
  <div
    class="header"
    :style="{
      background: `${colors[colors.theme].to}`,
    }"
  >
    <div class="header_content">
      <div class="bet">
        <div class="stage_icon">
          <BetCoin></BetCoin>
        </div>
        <div class="enigma_info gunmetal">
          <!-- <span class="enigma-step">{{$t("components.header.enigma_info_gunmetal.enigma-step")}}: {{enigmaStepView}}/4</span> -->
          <span class="premium-step" 
        :style="{'color': colors.theme == 'dark' ? '#FFF' : '#000'}"
            >{{ $t("components.header.enigma_info_gunmetal.premium-step") }}:
            <br />
            <strong >{{ (premiumView * 2).toLocaleString("pt-br") }}</strong></span
          >
        </div>
      </div>
      <div class="enigma_attempts">
        <span :style="{'color': colors.theme == 'dark' ? '#FFF' : '#000'}">{{ $t("components.header.enigma_attempts") }}</span>
        <div class="attempt" v-show="attempts[0].length == 0">
          <Attempt1></Attempt1>
          <Attempt2></Attempt2>
          <Attempt3></Attempt3>
        </div>
        <div class="attempt" v-show="attempts[0].length == 1">
          <AttemptWrong></AttemptWrong>
          <Attempt2></Attempt2>
          <Attempt3></Attempt3>
        </div>
        <div class="attempt" v-show="attempts[0].length == 2">
          <AttemptWrong></AttemptWrong>
          <AttemptWrong></AttemptWrong>
          <Attempt3></Attempt3>
        </div>
        <div class="attempt" v-show="attempts[0].length >= 3">
          <AttemptWrong></AttemptWrong>
          <AttemptWrong></AttemptWrong>
          <AttemptWrong></AttemptWrong>
        </div>
      </div>
      <div class="clock_info">
        <Clock v-if="!skull" class="clock_icon"></Clock>
        <ClockSkull v-if="skull" class="clock_icon"></ClockSkull>
        <span :style="{color: colors.theme == 'dark' ? colors.primary : '#000'}" class="clock_time">{{ timerView }}</span>
      </div>

      <game-modal
        v-show="!showModal"
        class="lightbox"
        :modalMessage="$t('components.header.enigma_attempts')"
      ></game-modal>
      <five-minutes-warning
        :showFeedback="feedback.showFeedback"
        :colorTheme="colors.theme"
        :attempt="feedback.attempt"
        :fiveMinutes="feedback.fiveMiutes"
      ></five-minutes-warning>
    </div>
  </div>
</template>

	<script>
var moment = require("moment");
moment.locale("pt-br");
import Modal from "../default/Modal";
import ModalWithOptions from "../default/ModalWithOptions";
import { Bus } from "@/event-bus.js";
import FiveMinutesWarning from "../default/FeedbackAttempt";
import Attempt1 from "../../shared/customIcons/enigmasAttempt/Attempt1";
import Attempt2 from "../../shared/customIcons/enigmasAttempt/Attempt2";
import Attempt3 from "../../shared/customIcons/enigmasAttempt/Attempt3";
import AttemptWrong from "../../shared/customIcons/enigmasAttempt/AttemptWrong";
import BetCoin from "../../shared/customIcons/betCoin";
import Clock from "../../shared/customIcons/Clock";
import ClockSkull from "../../shared/customIcons/ClockSkull";
export default {
  props: ["gameInfo", "attempts", "premium"],
  name: "Header",
  components: {
    Attempt1,
    Attempt2,
    Attempt3,
    BetCoin,
    AttemptWrong,
    Clock,
    ClockSkull,
    "game-modal": Modal,
    "modal-options": ModalWithOptions,
    "five-minutes-warning": FiveMinutesWarning,
  },

  data: function () {
    return {
      skull: false,
      moment: moment,
      showModal: true,
      urlGame: `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}`,
      timer: "",
      timerView: "10:00",
      lastView: "",
      premiumView: "",
      enigmaStepView: "",
      interval: "",
      teste: "",
      soloGame: "",
      modalOptionsData: {
        show: false,
        hideModal: "",
        modalTitle: "Seu tempo acabou :(",
        multiple: false,
        titleBtnOk: "Próximo enigma",
      },
      feedback: {
        showFeedback: false,
        attempt: "",
        fiveMiutes: true,
      },
      colors: {},
    };
  },
  destroyed() {
    clearInterval(localStorage.getItem("idInterval"));
    Bus.$off("endClock");
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    let self = this;
    window.addEventListener("blur", function () {
      localStorage.setItem("horaSaida", self.timerView);
    });
    clearInterval(localStorage.getItem("idInterval"));
    let initializeGame = localStorage.getItem("initializeGame");
    if (initializeGame) {
      this.lastView = undefined;
    } else {
      this.lastView = this.$store.getters.getSoloGame
        ? this.$store.getters.getSoloGame[
            this.$store.getters.getSoloGame.length - 1
          ]
        : [];
    }
    this.enigmaStepView = this.$store.getters.getSoloGame.length;
    Bus.$on("endClock", this.endClock);
    if (!this.lastView) {
      let gameSetId = localStorage.getItem("gameSetId");
      this.$http
        .get(
          `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`
        )
        .then((response) => {
          // console.log(
          //   "GAME: ",
          //   response.body.soloGames[response.body.soloGames.length - 1].id
          // );
          localStorage.setItem(
            "lastSoloID",
            response.body.soloGames[response.body.soloGames.length - 1].id
          );
          if (initializeGame) {
            let soloGames = response.body.soloGames;
            let now = moment(response.body.now);
            let lastSolo = this.defineLastSolo(soloGames);
            this.soloGame = lastSolo;
            let initGame = moment(lastSolo.createdAt);
            let secondsDiff = initGame.diff(now, "seconds");
            if (secondsDiff < -300) {
              let horaSaida = localStorage.getItem("horaSaida");
              let points = -300 - secondsDiff;
              setTimeout(function () {
                self.$store.commit("subScoreState", points);
              }, 1000);
            }
          }
          self.$store.commit("setNowState", response.body.now);
          self.lastView = self.defineLastSolo(response.body.soloGames);
          self.enigmaStepView = response.body.soloGames.length;
          self.initializeClock();
        });
    } else {
      this.initializeClock();
    }
  },
  methods: {
    defineLastSolo(soloGames) {
      if (soloGames.length < 2) return soloGames[0];
      let lastSolo = soloGames.reduce((a, b) => {
        return a.createdAt > b.createdAt ? a : b;
      });
      return lastSolo;
    },
    endClock(boolean) {
      clearInterval(this.interval);
    },
    hiddingModal(hide) {
      let self = this;
      self.modalOptionsData.show = false;
    },
    initializeClock() {
      let self = this;
      if (self.lastView) {
        self.premiumView = self.lastView.bet;
        let lastCreated = moment(self.lastView.createdAt);
        let now = moment(self.$store.getters.getNow);
        let secondsDiff = lastCreated.diff(now, "seconds");
        self.timer = moment.utc(secondsDiff * 1000);
        self.timer.subtract(50, "minutes");
        self.interval = setInterval(function () {
          localStorage.setItem("idInterval", self.interval);
          if (self.timerView == "00:00") {
            self.showFeedback("timeout");
            self.endClock(true);
            setTimeout(() => {
              Bus.$emit("timeout");
              // console.log("Passou pelo timeout");
            }, 1800);
          }
          if (self.timerView <= "05:00") {
            // self.skull = true;
            self.$store.dispatch("subScore", 1);
            self.$store.commit("setTimeDiscount", self.setSecondDiff());
            // console.log("Seconds DIFF: ", self.setSecondDiff());
          }
          // if (self.timerView == "05:00") {
          //   self.showFeedback("time_five_minutes");
          //   self.skull = true;
          // }
          if (self.timerView > "00:00" && self.timerView <= "10:00") {
            self.timer = self.timer.subtract(1, "seconds"); 
            self.timerView = self.timer.format("mm:ss");
          }
          if (self.timerView > "10:00") {
            self.endClock(true);
            Bus.$emit("timeout");
          }
          return "";
        }, 1000);
      } else {
        return "10:00";
      }
    },
    showFeedback(feedbackType) {
      var self = this;
      self.feedback.showFeedback = true;
      self.feedback.attempt = feedbackType;
      if (feedbackType == "timeout") self.feedback.fiveMiutes = false;
      setTimeout(() => {
        self.feedback.showFeedback = false;
        self.feedback.attempt = "_";
      }, 1800);
    },
    setSecondDiff() {
      let initGame = moment(this.soloGame.createdAt);
      let now = this.soloGame.now;
      let secondsDiff = initGame.diff(now, "seconds");
      return secondsDiff + 300;
    },
  },
};
</script>

<style lang="scss">
.header {
  background-color: rgba($color: #02f0e4, $alpha: 0.15);
  //height: 10vh;
  min-height: 55px;
  width: 100%;
  display:flex;

  .header_content {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: 100%;
    //padding-left:15px;
    //padding-right:15px;
    .bet{
      display: flex;
      width: 140px;
    }
    .stage_icon {
      //width: 15%;
      //width: 8%;
      width: 32px;
      //margin: 0 10px 0 0;
      //padding-right: 15px;
      .enigma-puzzle-index svg {
        height: 40px;
      }
    }
    .enigma_info {
      //width: 25%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 5px;
      //margin: 0 0 0 -10px;
      .enigma-step {
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
      .premium-step {
        font-size: 12px;
        margin-top: 2px;
        text-transform: uppercase;

        strong {
			font-weight: 900;
			//font-size: 21px;
      font-size: 16px;
        }
      }
    }
    .enigma_attempts {
      //width: 30%;
      //height: 60%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      //margin-right: 4%;
      margin-left: 5px;
      margin-right: 5px;
      white-space: nowrap;

      span {
        font-size: 7px;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
      .attempt {
        display: flex;
        justify-content: center;

        .attempt-icon {
          // width: 63px;

          svg{
            margin: 0 5px;
          }

          &:nth-child(2) {
            // margin: 0 -20px;
          }
        }
      }
    }
    .clock_info {
      //width: 24%;
      //width: 20%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .clock_icon {
        //width: 40%;
        width: 30px;
        max-width: 45px;
        margin-right: 5px;
      }
      .clock_time {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

@media only screen and (min-width: 375px) {
  .header {
    .header_content {
      .stage_icon {
        //width: 10%;
      }
      .enigma_info {
        //width: 22%;
      }
      .enigma_attempts {
        //margin-right: 7%;
        span {
          font-size: 9px;
        }
        .attempt {
          img {
            height: 22px;
          }
        }
      }
      .clock_info {
        .clock_time {
          font-size: 16px;
        }
      }
    }
  }
}
@media only screen and (min-width: 500px) {
  .header {
    .header_content {
      .stage_icon {
        img {
          height: 50px;
        }
      }
      .enigma_info {
        .enigma-step {
          font-size: 0.9em;
        }
        .premium-step {
          font-size: 10px;
          strong{
            font-size: 21px;
          }
        }
      }
      .enigma_attempts {
        span {
          font-size: 11px;
        }
        .attempt {
          img {
            height: 25px;
          }
        }
      }
      .clock_info {
        .clock_time {
          font-size: 17px;
        }
      }
    }
  }
}
@media only screen and (min-width: 600px) {
  .header {
    .header_content {
      .bet{
        // width: 140px;
      }
      .stage_icon {
        //width: 5%;
        .enigma-puzzle-index {
          svg {
            height: 65px;
          }
        }
      }
      .enigma_info {
        .enigma-step {
          font-size: 1.1em;
        }

        .premium-step {
          font-size: 12px;
          strong{
            font-size: 21px;
          }
        }
      }
      .enigma_attempts {
        .attempt {
          //width: 80%;
          margin: 0 auto;
          img {
            height: 28px;
          }
        }
      }
      .clock_info {
        width: 140px;
        .clock_time {
          //margin-right: 15px;
          font-size: 21px;
        }
      }
      .attempt-icon svg {
        height: 32px;
      }
    }
  }
}
@media only screen and (min-width: 750px) {
  .header {
    height: 7vh;
    .header_content {
      .stage_icon {
        // width: 1%;
        img {
          height: 50px;
        }
      }
      .enigma_attempts {
        //margin-right: 10%;
        .attempt {
          img {
            height: 30px;
          }
        }
      }
      .clock_info {
        width: 15%;
        .clock_time {
          //font-size: 19px;
        }
      }
    }
  }
}
</style>
